(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('CommentDeleteController',CommentDeleteController);

    CommentDeleteController.$inject = ['$uibModalInstance','entity','Comment','ToastrService','$scope','MiscService',
                                        'shipmentEntity','contractEntity','lotEntity','invoiceEntity','requiredDocumentEntity','controllerEntity','controllerPaymentEntity'];

    function CommentDeleteController($uibModalInstance, entity, Comment, ToastrService, $scope, MiscService,
                                     shipmentEntity, contractEntity, lotEntity, invoiceEntity, requiredDocumentEntity, controllerEntity, controllerPaymentEntity) {
        var vm = this;

        vm.comment = entity;
        vm.comment.contract = contractEntity;
        vm.comment.shipment = shipmentEntity;
        vm.comment.lot = lotEntity;
        vm.comment.invoice = invoiceEntity;
        vm.comment.requiredDocument = requiredDocumentEntity;
        vm.comment.controller = controllerEntity;
        vm.comment.controllerPayment = controllerPaymentEntity;
        vm.modComment = angular.copy( vm.comment );

        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        vm.nl2br = MiscService.nl2br;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete () {
            vm.modComment.active = false;
            if( vm.modComment.id !== null ) {
                Comment.delete({id: vm.comment.id}, onSaveSuccess, onSaveError );
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('ccsTrApp:commentUpdate', result);
            $uibModalInstance.close(true);
            vm.isSaving = false;
        }

        function onSaveError () {
            ToastrService.error( "Something went wrong", "Error!" );
            vm.isSaving = false;
        }
    }
})();
